var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
var About = /** @class */ (function (_super) {
    __extends(About, _super);
    function About(props) {
        return _super.call(this, props) || this;
    }
    About.prototype.render = function () {
        return (React.createElement("section", { className: "content2", id: "2" },
            React.createElement("h3", null, "Leave the installation to us."),
            React.createElement("img", { alt: "Service Tech", className: "imgR", src: "img/service-tech.png" }),
            React.createElement("h5", null, "InstallerNet, Inc."),
            React.createElement("p", null, "InstallerNet, inc. is a technology and service company that specializes in merchandising and coordinating consumer electronics installation services through the Nation\u2019s leading network of independently owned businesses with smart home experts. Our network of professional installers combined with proprietary web and call-center technologies provides the powerful core enabling WeatherFlow to offer Tempest owners a professional installation option to consider before, during, or after their Tempest purchase to enhance satisfaction in their Tempest experience. Please call (800) 806-5513 to schedule your installation appointment."),
            React.createElement("div", { className: "clearFix" }),
            React.createElement("div", { className: "arrowBox" })));
    };
    return About;
}(Component));
export default About;
